export default function convertNumber(number) {
  let finalNumber = '';

  for (let i = 0; i < number.length; i += 1) {
    if (i === 0 || i === 1 || i === 2) {
      // eslint-disable-next-line no-continue
      continue;
    }
    if (i === 3 || i === 7 || i === 8 || i === 12) {
      // eslint-disable-next-line no-continue
      continue;
    }
    finalNumber += number[i];
  }

  return finalNumber;
}
